import {
    SIGN_OUT,
    FETCH_LOANS_BEGIN,
    FETCH_LOANS_SUCCESS,
    FETCH_LOANS_FAILURE,
    CLEAR_SELECTED_LOAN,
    SET_SELECTED_LOAN,
} from "../actions/types";

const initialState = {
    items: null,
    loading: false,
    error: null,
    selectedLoan: null
}

export default function loanReducer(
    state = initialState,
    action
) {
    switch(action.type) {
        case SIGN_OUT:
            return initialState;

        case FETCH_LOANS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            }

        case FETCH_LOANS_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.payload.loans
            }
        
        case FETCH_LOANS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                items:[]
            }
        case CLEAR_SELECTED_LOAN:
            return {
                ...state,
                selectedLoan: null
            }
        
        case SET_SELECTED_LOAN:
            return {
                ...state,
                selectedLoan: action.payload.loan
            }
        default:
            return state;
    }
}